import { computed, ref, Ref } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";
import { StepData } from "@/types";

export default function useStepperData<T extends string>(stepsArray: Ref<readonly T[]>) {
  const stepperElRef = ref<HTMLElement>();
  const currentStep = ref(1);

  const steps = computed(() => {
    return stepsArray.value.reduce<Record<T, StepData>>(
      (acc, item, index) => {
        acc[item] = {
          step: index + 1,
        };
        return acc;
      },
      {} as Record<T, StepData>
    );
  });

  const getStepName = (step: number) => {
    return "step-" + step;
  };

  const onCurrentStepChange = () => {
    getElement<HTMLElement>(stepperElRef.value).scrollIntoView({
      block: "start",
      behavior: "auto",
    });
  };

  return { stepperElRef, currentStep, steps, getStepName, onCurrentStepChange };
}
